import { graphql } from 'gatsby';
import React from 'react';
import { useMicrosite } from '../../contexts/franchise/microsite-context.tsx';
import Container from '../atoms/Container';
import { colors } from '../primitives/colors';
import Link from '../primitives/link';
import Typography from '../primitives/typography';
import paddingDefault from '../utils/paddingDefault';

const ServiceArea = ({ data }) => {
    const { title } = data || {};

    const {
        franchise: {
            activeMarkets,
        },
    } = useMicrosite();

    if (!!activeMarkets && activeMarkets?.length > 0) {
        return (
            <Container css={paddingDefault(null, true)}>
                <Typography
                    as="h4"
                    fontSize={{
                        dt: '2xl',
                        mb: 'xl',
                    }}
                    css={{
                        marginBottom: '12px',
                    }}
                >
                    {title}
                </Typography>
                <Typography fontSize={{
                    dt: 'lg',
                    mb: 'md',
                }}
                >
                    {activeMarkets.map((activeMarket, idx) => {
                        const { city, state } = activeMarket;
                        const place = [city, state].filter(x => !!x).join(', ');
                        if (activeMarket.link) {
                            return (
                                <span>
                                    <Link
                                        css={{
                                            textDecoration: 'underline',
                                            transition: '0.3s',
                                            '&:hover': {
                                                color: colors.primaryGreen,
                                            },
                                        }}
                                        to={(activeMarket.link || '')}
                                    >
                                        {place}
                                    </Link>
                                    {idx !== activeMarkets.length - 1 && ' | '}
                                </span>
                            );
                        }

                        return (
                            <span>
                                {place}
                                {idx !== activeMarkets.length - 1 && ' | '}
                            </span>
                        );
                    })}
                </Typography>
            </Container>
        );
    }

    return null;
};

export const query = graphql`
    fragment ServiceAreaData on CmsPageBuilderBlocks {
        service_area {
            title
        }
    }
`;

export default ServiceArea;
